<template>
  <div class="modal-backdrop">
    <div class="modal-container standard-size">
      <input
        type="file"
        style="display: none"
        ref="fileInput"
        accept="text/plain, application/pdf"
        @change="onFilePicked"
        multiple
      />
      <div class="fileListWrapper" v-if="showUploadList">
        <div class="fileListItems">
          <div class="fileNameList">
            <li
              class="listItem"
              v-for="(file, index, key) in selectedFiles"
              :key="key"
            >
              <v-icon
                name="times"
                class="removePDFIcon"
                @click="removeFromTheUploadList(index)"
                :style="[
                  !showUploadSpinner
                    ? { color: 'var(--grey-dark)' }
                    : { color: 'var(--grey)' },
                ]"
              ></v-icon>
              <p class="h3 remove--margin-bottom remove--margin-top">
                {{ file.name.slice(0, 50) }}
              </p>
            </li>
          </div>
        </div>
        <div class="button-container">
          <button class="button-neutral" @click="closeuploadPDF()">
            CANCEL
          </button>
          <button class="button-neutral" @click="this.browseFiles">
            ADD MORE FILES
          </button>
          <button
            class="button-positive"
            @click="this.uploadToFirebaseStorage"
            :disabled="this.selectedFiles.length == 0"
          >
            UPLOAD<v-icon
              name="circle-notch"
              class="loading-icon"
              spin
              v-if="this.showUploadSpinner"
            ></v-icon>
          </button>
        </div>
      </div>
      <div class="SuccessWrapper" v-if="uploadSuccessModal">
        <v-icon name="check-circle" scale="5" color="#48B9BA"></v-icon>
        <h3 class="h2 add--margin-bottom">Your files have been uploaded</h3>
        <button class="button-neutral" @click="closeuploadPDF()">CLOSE</button>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/bus.js";
import { db, storage } from "@/firebase.js";

export default {
  components: {},
  data() {
    return {
      selectedFiles: [],
      showUploadList: true,
      uploadSuccessModal: false,
      showBrowseFiles: true,
      showUploadSpinner: false,
    };
  },
  mounted() {
    this.browseFiles();
  },
  methods: {
    browseFiles() {
      this.$refs.fileInput.click();
    },
    closeuploadPDF() {
      bus.$emit("closeuploadPDF");
    },
    onFilePicked(event) {
      const files = event.target.files;
      for (var i = files.length - 1; i >= 0; i--) {
        this.selectedFiles.push(files[i]);
        this.showUploadList = true;
      }
    },
    removeFromTheUploadList(arrayIndex) {
      this.selectedFiles.splice(arrayIndex, 1);
    },
    async uploadToFirebaseStorage() {
      this.showUploadSpinner = true;
      this.showBrowseFiles = false;

      await Promise.all(
        this.selectedFiles.map(async (file) => {
          const key = db.ref(`files/${this.$customerId}/${this.$hotelId}`).push().key;

          const storageRef = storage.ref(
            `${this.$hotelId}/${key}.${file.name}`
          );

          await storageRef.put(file);

          const url = await storageRef.getDownloadURL();

          return db
            .ref(`files/${this.$customerId}/${this.$hotelId}/${key}`)
            .update({ url, fileName: file.name });
        })
      );

      this.selectedFiles = [];
      this.showUploadList = false;
      this.uploadSuccessModal = true;
      this.showUploadSpinner = false;
    },
    loadMediaLibrary() {
      bus.$emit("closeuploadPDF");
    },
  },
};
</script>

<style scoped>
.loading-icon {
  vertical-align: middle;
  margin-left: 10px;
}
.SuccessWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.browseFiles {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  cursor: pointer;
}
.fileListWrapper {
  height: calc(100% - 20px);
}
.fileListWrapper > div.buttonWrap {
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;
}
.listItem {
  display: flex;
  flex-direction: row;
  align-items: middle;
  vertical-align: middle;
}
.fileListItems {
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 300px;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fileListItems div {
  max-height: 300px;
}
.fileListItems div li {
  text-align: left;
  display: flex;
  align-items: center;
}
.fileNameList {
  margin-left: 5px;
  display: flex;
  flex-direction: column;
}
.removePDFIcon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
}
</style>
